<template>
  <div ref="wrapper" class="render-wrapper" :style="styleList" :class="classList">
    <div class="edit-btn-group" ref="btnGroup" v-if="!isPreview && isEditMode">
      <el-button v-if="hasChildren" class="add-child-btn" @click="onAddChildBtnClik">{{ $t('microSite.editor.common.addComponent') }}</el-button>
      <el-button class="edit-btn" @click="onEditBtnClick">{{ $t('microSite.editor.common.edit') }}</el-button>
    </div>
    <van-sticky v-if="sticky" ref="sticky" class="sticky-container" @scroll="handleStickyScroll">
      <slot></slot>
    </van-sticky>
    <slot v-else></slot>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    hasChildren: {
      type: Boolean,
      default: false
    },
    sticky: {
      type: Boolean,
      default: false
    },
    styleList: {
      default: null
    },
    classList: {
      default: null
    }
  },
  data () {
    return {
      stickyStyle: {}
    }
  },
  computed: {
    ...mapGetters('microSite', ['isEditMode', 'isPreview', 'currentPage'])
  },
  created () {

  },
  methods: {
    onEditBtnClick () {
      if (!this.isEditMode) {
        return
      }
      this.$emit('openEditor')
    },
    onAddChildBtnClik () {
      if (this.isPreview || !this.isEditMode) {
        return
      }
      this.$emit('openChildEditor')
    },
    handleStickyScroll (params) {
      const stickyEl = this.$refs.sticky.$el
      if (params.isFixed) {
        this.$nextTick(() => {
          const rect = this.$refs.wrapper.getBoundingClientRect()
          const fixEl = stickyEl.querySelector('.van-sticky--fixed')
          fixEl.style.width = `${rect.width}px`
        })
      }
      if (!this.isPreview && this.isEditMode) {
        const btnGroup = this.$refs.btnGroup
        if (params.isFixed) {
          const rect = this.$refs.wrapper.getBoundingClientRect()
          const btnRect = btnGroup.getBoundingClientRect()
          btnGroup.style.position = 'fixed'
          btnGroup.style.top = '62px'
          btnGroup.style.zIndex = '100'
          btnGroup.style.right = `${window.innerWidth - btnRect.right}px`
          // btnGroup.style.left = rect.right + 'px'
          this.$nextTick(() => {
            const fixEl = stickyEl.querySelector('.van-sticky--fixed')
            fixEl.style.top = '52px'
            fixEl.style.left = `${rect.left}px`
            fixEl.style.width = `${rect.width}px`
          })
        } else {
          btnGroup.style.position = null
          btnGroup.style.top = null
          btnGroup.style.left = null
          btnGroup.style.right = null
          btnGroup.style.zIndex = null
        }
      }
      this.$emit('stickyScroll', params, this.$refs.sticky, this.$refs.wrapper)
    }
  }
}
</script>

<style lang="scss" scoped>
.site-common {
  .render-wrapper {
    margin: 0 auto;
    position: relative;
    margin-top: 50px;

    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
      // padding-bottom: 50px;
    }

    &.navigation-wrapper {
      .edit-btn-group {
        z-index: 100;
        right: 90px;
      }
    }

    .edit-btn-group {
      position: absolute;
      top: 10px;
      right: 20px;
      z-index: 10;

      .el-button {
        width: 95px;
        padding: 8px 20px;
        height: 32px;
        color: #fff;
        background-color: #008dc2;
      }
    }
  }
}
.site-mobile {
  .render-wrapper {
    margin-bottom: 35px;
  }
}
.site-pc {
  .render-wrapper {
    width: 1366px;
  }
  &:not(.edit-mode):not(.site-previewer) {
    .render-wrapper {
      ::v-deep {
        .sticky-container {
          .van-sticky--fixed {
            left: initial;
            right: initial;
          }
        }
      }
    }
  }
}
</style>
